/* [ТЕЛЕГРАМ] Отступ полного экрана (Bot API 8.0+): сверху поверх приложения лежат вырез экрана и кнопки Telegram «Закрыть» и «⋁ ⋮».
   На <html>: --safe-sys (вырез и строка состояния), --safe-bar (ряд кнопок Telegram), --safe-top (их сумма); при --safe-top > 0 —
   класс tgfs на телефоне (полоса под кнопками Telegram) или tgfd на компьютере (Telegram Desktop на весь экран: сцена просто ниже кнопок Telegram);
   раскладка — src/app.css; полоса под кнопками Telegram — сплошная, цвета фона приложения.
   Нижний отступ Telegram (системная панель Android «□ ○ ◁») не учитывается: Telegram сообщает его, даже когда панель спрятана, и меню висело бы
   над пустым местом (bugs.telegram.org/c/65941). 30.10.2026 его пробовали учитывать (--tg-sab → --sab, src/app.css) и вернули: меню прилеплено к низу.
   Telegram присылает отступы событиями уже после первой отрисовки: чтобы скелетон не съезжал вниз,
   значения прошлого запуска ставятся сразу, а при самом первом запуске приложение скрыто (html.sa-wait), пока отступ не придёт. */

const KEY = 'steos:safe-top2';
const WAIT_MS = 800;

type Top = { sys: number; bar: number };

function cached(): Top | null {
  try {
    const [sys, bar] = (localStorage.getItem(KEY) || '').split(',').map(Number);
    return sys + bar > 0 ? { sys, bar } : null;
  } catch {
    return null;
  }
}

function remember(v: Top) {
  try {
    localStorage.setItem(KEY, v.sys + ',' + v.bar);
  } catch {
    /* приватный режим */
  }
}

/** fullscreen — приложение запросило полный экран и ждёт его (platform/index.ts openFull) */
export function installSafeArea(tg: TelegramWebApp, fullscreen: boolean) {
  const root = document.documentElement;
  const phone = tg.platform === 'ios' || tg.platform === 'android';
  const read = (): Top => ({ sys: tg.safeAreaInset?.top || 0, bar: tg.contentSafeAreaInset?.top || 0 });
  const set = (v: Top) => {
    /* нижний отступ Telegram (системная панель Android «◁ ○ □») не берём: Telegram сообщает его и при скрытых кнопках (bugs.telegram.org/c/65941),
       и меню висело над пустым местом. Владелец 30.10.2026: меню прилеплено к низу. Вернуть подъём — --tg-sab из tg.safeAreaInset.bottom (--sab, app.css) */
    root.style.setProperty('--tg-sab', '0px');
    root.style.setProperty('--safe-sys', v.sys + 'px');
    root.style.setProperty('--safe-bar', v.bar + 'px');
    root.style.setProperty('--safe-top', v.sys + v.bar + 'px');
    root.classList.toggle('tgfs', phone && v.sys + v.bar > 0);
    root.classList.toggle('tgfd', !phone && v.sys + v.bar > 0);
    /* Android: кнопки Telegram стоят в 8 px от краёв экрана — по ним выравниваются боковые поля «Озвучки» (src/app.css) */
    root.classList.toggle('tga', tg.platform === 'android' && v.sys + v.bar > 0);
  };

  let waiting = fullscreen;
  let timer = 0;
  const done = () => {
    waiting = false;
    clearTimeout(timer);
    root.classList.remove('sa-wait');
  };
  const apply = () => {
    const v = read();
    /* полный экран ещё не включился или его отступ ещё не пришёл — держим значения прошлого запуска */
    if (waiting && (!tg.isFullscreen || v.sys + v.bar === 0)) return;
    done();
    set(v);
    if (tg.isFullscreen && v.sys + v.bar > 0) remember(v);
  };

  if (waiting) {
    const last = cached();
    if (last) set(last);
    else root.classList.add('sa-wait');
    timer = window.setTimeout(() => {
      done();
      set(read());
    }, WAIT_MS);
  }
  for (const e of ['safeAreaChanged', 'contentSafeAreaChanged', 'fullscreenChanged']) tg.onEvent(e, apply);
  tg.onEvent('fullscreenFailed', () => {
    done();
    apply();
  });
  apply();
}
